import React from "react";
import Avatar from "react-avatar";

const DefaultAvatar = React.forwardRef(({ children, onClick, pseudo }, ref) => (
  <div
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <Avatar name={pseudo} size="2.5rem" round="100%" bsRole="toggle" />
  </div>
));

export default DefaultAvatar;
